import {t} from '@lingui/core/macro';
import {createAsyncThunk} from '@reduxjs/toolkit';

import {ApiUrls} from 'shared/config/model/urls';
import createHttpRequest from 'shared/api/http';
import {setTokens} from 'shared/api/auth';

import ConfirmEmailData from '../ConfirmEmailData';
import IConfirmEmailChangeResponse from '../IConfirmEmailChangeResponse';

export const confirmChangeEmail = createAsyncThunk<IConfirmEmailChangeResponse, ConfirmEmailData>(
    'auth/confirmChangeEmail',
    async({userId, token}) => {
        const response = await createHttpRequest({
            method: 'POST',
            data: {},
            path: ApiUrls.CHANGE_EMAIL_CONFIRM(userId, token),
            errorMessage: t`Произошла ошибка`,
            silent: true,
            isAnonymous: false,
        });

        setTokens(response.data.authTokens);

        return response.data;
    },
);
